import React, { lazy, useEffect, useState } from 'react';
import './Calendar.scss';
import { getYear } from 'date-fns';
import { observer } from 'mobx-react';
import SpecialDaysStore from '../../store/SpecialDays';
import { CalendarStore } from '../../store/Calendar';
import { LocationPanel } from './LocationPanel';
import { CalendarContent } from './CalendarContent';
import { CountryListStore } from '../../store/CountryList';
import { useEffectOnce } from 'react-use';
import { buildModal } from '../../containers/MainWrapper/modal/ModalBuilder';
import { SpecialDay } from '../../types';
import { SpinnerPortal } from '../planner/Planner';
import { useUsageStatistics } from '../../utils/hooks';
import apiConfig from '../../api/routes';

const ChooseEventTypeModal = lazy(()=> import('./modals/ChooseEventTypeModal'));
const CreateEventModal = lazy(()=> import('./modals/CreateEventModal'));
const EditEventModal = lazy(()=> import('./modals/EditEventModal'));
const DeleteEventModal = lazy(()=> import('./modals/DeleteEventModal'));

export function usePartialState<T>(changes: Partial<T>): (state: T) => T & Partial<T> {
  return (state: T) => ({ ...state, ...changes });
}
export const navCalendarItems = [
  {value: 'Year', text: 'Year' },
  {value: 'Month', text: 'Month' },
  {value: 'List', text: 'List' },
];

export interface ListSpecialDaysPayloadI {
  year?: number,
  country: string,
  user_id?: number
}

export type ModalBaseProps = {
  specialDays: Partial<SpecialDay>,
  setDataSource: (data: SpecialDay[])=> void,
  dataSource: ReadonlyArray<SpecialDay>
}

export type ChooseEventTypeModalT = {
  specialDays: Partial<SpecialDay> | null,
  setDataSource: (data: SpecialDay[])=> void,
  dataSource: ReadonlyArray<SpecialDay>
}

export const chooseEventTypeModalCall =
  buildModal<undefined, ChooseEventTypeModalT>((data,close) => <ChooseEventTypeModal data={data} onClose={close}/> );
export const createEventModalCall =
  buildModal<undefined, ModalBaseProps>((data,close) => <CreateEventModal data={data} onClose={close}/>);
export const editEventModalCall =
  buildModal<undefined, ModalBaseProps>((data,close) =>  <EditEventModal data={data} onClose={close}/>);
export const deleteEventModalCall =
  buildModal<undefined, ModalBaseProps>((data, close) => <DeleteEventModal data={data} onClose={close}/>);

export const CalendarPage = observer(() => {
  const { getUserLocation } = CountryListStore;
  const { getCalendarSettings, updateCalendarType, calendarSettings, areSettingsFetched, tableData, updateCalendarTableData } = CalendarStore;
  const { getListSpecialDays } = SpecialDaysStore;
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [listSpecialDays, setListSpecialDays] = useState<SpecialDay[]>([]);

  useUsageStatistics(apiConfig.statisticsUsageService.calendarPage);

  useEffect(()=> {
    if (!areSettingsFetched) {
      getCalendarSettings();
    }
  }, []);

  useEffectOnce(() => {
    getUserLocation();
  });

  useEffect(() => {
    if(calendarSettings.country){
      setIsLoadingList(true);
      getListSpecialDays({ year: getYear(tableData.date), country: calendarSettings.country }).then(res => {
        setListSpecialDays(res);
        setIsLoadingList(false);
      });
    }
  }, [tableData, calendarSettings.country]);

  const capitalizeFirstLetter = (s: string) => s[0].toUpperCase() + s.slice(1).toLowerCase();

  return (
    <div className={'calendar_wrapper'}>
      <SpinnerPortal isRender={isLoadingList}/>

      {areSettingsFetched && <>
        <LocationPanel location={calendarSettings.country} />
        <CalendarContent activeTable={capitalizeFirstLetter(calendarSettings.calendarType)}
          setActiveTable={updateCalendarType}
          setDataSource={setListSpecialDays}
          tableData={tableData}
          dataSource={listSpecialDays}
          setTableData={updateCalendarTableData} />
      </>
      }
    </div>
  );
});
